<template>
  <div>
    <b-card title="Card Title" no-body>
      <Header />
    </b-card>
    <b-card-body class="shadow p-3 mb-5 bg-white rounded">
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-danger"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
      >
        <b-tab title="Upload Logs" active>
          <div>
            <b-col sm="7" md="3" class="pagination float-right mb-4">
              <h5 class="text-dark mr-2 mt-1">Perpage</h5>
              <b-form-select
                v-model="perPage"
                :options="pageOptions"
              ></b-form-select>
              <b-pagination
                size="md"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
            <div class="responsive-table-main-div">
              <b-table
                show-empty
                :busy="isBusy"
                :items="posts"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                class="text-left"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(file_name)="data">
                  <a :href="`${data.item.file_url}`" download>{{
                    (data && data.value) || ""
                  }}</a>
                </template>
                <template #cell(invalid_file_url)="data">
                  <a :href="`${data.value}`" download>{{
                    (data &&
                      data.value.split("/") &&
                      data.value.split("/")[4] &&
                      data.value.split("/")[4].split(".")[0]) ||
                    ""
                  }}</a>
                </template>
              </b-table>
            </div>
          </div></b-tab
        >
        <b-tab title="Upload File"
          ><CsvUpload @getUploadLogs="getUploadLogs"
        /></b-tab>
      </b-tabs>
    </b-card-body>
  </div>
</template>

<script>
import CsvUpload from "./CsvUpload.vue";
import useJwt from "../../auth/jwt/useJwt";
import { CSVUPLOAD_LOGS_QUERY } from "../../graphql/fetch-grphql";
import { toastification } from "../../@core/mixins/toastification";
import Header from "./Header.vue";
export default {
  name: "FileUpload",
  data() {
    return {
      posts: [],
      isBusy: false,
      fields: [
        {
          key: "created_at",
          label: "Date",
        },
        {
          key: "file_name",
          label: "File Name",
        },
        {
          key: "invalid_file_url",
          label: "File Of Invalid Data",
        },
        {
          key: "total_added_rows",
          label: "Total Added Rows",
        },
        {
          key: "total_invalid_rows",
          label: "Total Invalid Rows",
        },
      ],
      pageOptions: [5, 10, 20, 50],
      currentPage: 1,
      perPage: 10,
    };
  },
  mixins: [toastification],
  components: {
    CsvUpload,
    Header,
  },
  beforeMount() {
    this.getUploadLogs();
  },
  computed: {
    totalRows() {
      return this.posts.length;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.clear();
      if (this.$route.path != "/") {
        this.$router.push("/");
      }
    },
    async getUploadLogs() {
      this.isBusy = true;
      await this.$apollo
        .query({
          query: CSVUPLOAD_LOGS_QUERY,
        })
        .then((res) => {
          this.posts = res.data.userUploads.data;
          res.data.userUploads.data.forEach((element) => {
            let data = element.created_at;
            let date = new Date(parseInt(data));
            element.created_at = `${date.getDate()}/${
              parseInt(date.getMonth()) + 1
            }/${date.getFullYear()}`;
          });
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.makeToastFail(err);
        });
    },
  },
};
</script>

<style scoped>
.responsive-table-main-div {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.pagination .custom-select {
  width: 75px !important;
}
@media only screen and (min-width: 360px) and (max-width: 736px) {
  .pagination {
    flex-wrap: wrap !important;
  }
  .p-3 {
    padding: unset !important;
  }
  .w-75 {
    width: auto !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .pagination {
    flex-wrap: inherit !important;
    float: left !important;
  }
  .p-3 {
    padding: unset;
  }
  .w-75 {
    width: auto;
  }
}
</style>
